import { initMonitor } from '@tsign/report-error'

if (process.env.VUE_APP_ARMS_MODE !== 'local') {
  initMonitor({
    pid: 'fkmlak58tj@e32033828778906',
    appType: 'web',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    enableLinkTrace: true,
    useFmp: true,
    behavior: true,
    enableConsole: true,
    enableSPA: true,
    sample: 2,
    environment: 'prod', // process.env.VUE_APP_ARMS_MODE, // prod表示线上环境 | gray表示灰度环境 | pre表示预发环境(对标模拟环境) | daily表示日常环境(对标稳定环境) | local表示本地环境(对标项目环境/本地)
  })
}
